import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import { serviceDetails, siteConfig } from '@/mocks/data';

const serviceImages = [
  'https://readdy.ai/api/search-image?query=Dark%20anthracite%20gray%20Fineco%20heat%20pump%20outdoor%20unit%20on%20modern%20villa%20wall%2C%20professional%20HVAC%20installation%2C%20clean%20minimalist%20architecture%2C%20warm%20natural%20lighting&width=800&height=600&seq=service-detail-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20radiator%20floor%20heating%20system%20in%20luxury%20living%20room%2C%20warm%20interior%2C%20contemporary%20design%2C%20cozy%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=service-detail-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20solar%20panels%20on%20luxury%20villa%20roof%2C%20blue%20sky%2C%20sustainable%20energy%2C%20clean%20technology%2C%20professional%20architectural%20photography&width=800&height=600&seq=service-detail-3&orientation=landscape',
];

const serviceIcons = ['ri-temp-hot-line', 'ri-radar-line', 'ri-sun-line'];

export default function ServicesPage() {
  const getWhatsappHref = (message: string) =>
    `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <section className="py-16 md:py-20 bg-secondary-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl md:text-5xl text-background-50 mb-4">Hizmetlerimiz</h1>
            <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              Atak Sistem Enerji olarak Balıkesir ve bölge illerde ısı pompası, kat kaloriferi ve güneş enerjisi sistemleri alanında profesyonel çözümler sunuyoruz.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col gap-12 md:gap-16">
              {serviceDetails.map((service, idx) => (
                <div key={service.id} className={`flex flex-col ${idx % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 md:gap-12 items-start`}>
                  <div className="lg:w-1/2">
                    <div className="w-16 h-16 rounded-lg bg-primary-100 flex items-center justify-center mb-5">
                      <i className={`${serviceIcons[idx]} text-primary-600 text-2xl w-8 h-8 flex items-center justify-center`}></i>
                    </div>
                    <h2 className="font-heading text-xl md:text-3xl text-foreground-900 mb-4">{service.title}</h2>
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">{service.description}</p>

                    <div className="mb-6">
                      <h3 className="font-heading text-base text-foreground-900 mb-3">Avantajlar</h3>
                      <div className="flex flex-col gap-2">
                        {service.advantages.map((adv, i) => (
                          <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                            <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                              <i className="ri-check-line text-primary-600 text-xs w-3 h-3 flex items-center justify-center"></i>
                            </div>
                            {adv}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h3 className="font-heading text-base text-foreground-900 mb-3">Kimler İçin Uygun?</h3>
                      <div className="flex flex-wrap gap-2">
                        {service.suitableFor.map((s, i) => (
                          <span key={i} className="inline-flex items-center gap-1.5 bg-background-100 text-foreground-600 text-xs px-3 py-1.5 rounded-full border border-background-200/70 whitespace-nowrap">
                            <i className="ri-user-line text-primary-500 w-3 h-3 flex items-center justify-center"></i>
                            {s}
                          </span>
                        ))}
                      </div>
                    </div>

                    <a
                      href={getWhatsappHref(service.whatsappMessage)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-[#25D366] text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-[#1faa51] transition-colors whitespace-nowrap"
                    >
                      <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                      WhatsApp'tan Bilgi Al
                    </a>
                  </div>
                  <div className="lg:w-1/2">
                    <div className="rounded-lg overflow-hidden bg-background-100 aspect-[4/3]">
                      <img
                        src={serviceImages[idx]}
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}